import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import Select from "react-select";
import { Button, Badge, Tooltip, OverlayTrigger, Dropdown, Row, Col, Tab, Nav } from "react-bootstrap";
import Drawer from '@mui/material/Drawer';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import DatePicker from "react-multi-date-picker";
import Payment from './../../../modal/subscription/Payment';
import Renewal from './../../../modal/subscription/Renewal';
import new_subs from '../../../../images/new_subs.gif';
import csv_ico from '../../../../images/export_icons/csv.ico';
import excel_ico from '../../../../images/export_icons/excel.ico';
import print_ico from '../../../../images/export_icons/print.ico';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import break_box from '../../../../images/product/break_box.png';
import lunch_box from '../../../../images/product/meals_box.png';
import dinner_box from '../../../../images/product/dinner_box.png';
import swal from "sweetalert2";
import UpdateRefund from '../../../modal/Payment_Management/Manage_Refund/CateringEdit'

import axios from 'axios';
import * as XLSX from 'xlsx';
import Papa from 'papaparse';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const getStartOfWeek = (date) => {
    const day = date.getDay(), // get the current day of the week
        diff = date.getDate() - day; // calculate the difference in days to the previous Sunday
    const startOfWeek = new Date(date.setDate(diff));
    startOfWeek.setHours(0, 0, 0, 0); // set to midnight
    return startOfWeek;
};

const getEndOfWeek = (date) => {
    const day = date.getDay(),
        diff = date.getDate() + (6 - day); // calculate the difference to the next Saturday
    const endOfWeek = new Date(date.setDate(diff));
    endOfWeek.setHours(23, 59, 59, 999); // set to the end of the day
    return endOfWeek;
};

const Refund = () => {
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const imgBaseUrl = process.env.REACT_APP_IMG_BASE_URL;
    const [datas, setData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);

    // pagination
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(25);

    // page table data fetch
    const fetchData = (filter = {}) => {
        const params = {
            ...filter,      // spread existing filter key-values
            page,           // add page number
            per_page: perPage, // add per_page
            search: searchTerm,  // add search string
            branch_id: branch_id, // add branch_id
        };
        axios.get(`${baseURL}/payment/catering_refund`, { params: params })
            .then(response => {
                setData(response.data.data);
                setHasFetched(true);
                setTotalPages(response.data.last_page);
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                setHasFetched(true);
            });
    };

    useEffect(() => {
        fetchData();
    }, [page, searchTerm, perPage]);

    const formatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const [modalType, setModalType] = useState("");
    const [open, setOpen] = useState(false);
    const tableRef = useRef(null);
    const [filterOpen, setFilterOpen] = useState(false);
    const onClose = () => {
        setFilterOpen(false);
    };


    // ------------------------------------------- Filter Details -------------------------------

    // prods option & on select
    const [filter_prods_id, setFilterProdsID] = useState(null);
    const [productsOpt, setProductsOpt] = useState([]);
    useEffect(() => {
        axios.get(`${baseURL}/manage-products/products/active`)
            .then(response => {
                const formatted = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.product_name,
                }));
                const allOption = { value: null, label: "All" };
                setProductsOpt([allOption, ...formatted]);
            })
            .catch(error => {
                console.error('There was an error fetching the data!', error);
            });
    }, []);

    // timeline option & on select
    const [filter_tline_id, setFilterTlineID] = useState(null);
    const [timelineoptions, setTimelineoption] = useState([]);
    useEffect(() => {
        axios.get(`${baseURL}/package-timeline/active`)
            .then(response => {
                const formatted = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.packagetimeline_name,
                }));
                const allOption = { value: null, label: "All" };
                setTimelineoption([allOption, ...formatted]);
            })
            .catch(error => {
                console.error('There was an error fetching the data!', error);
            });
    }, []);

    //area
    const [areaOption, setAreaOption] = useState([]);
    const [area, setArea] = useState(null);
    useEffect(() => {
        const fetchLeadSource = async () => {
            try {
                const response = await axios.get(`${baseURL}/dropdown/area`, { params: { branch_id } });
                const formattedsource = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.area_name,
                }));
                const allOption = { value: null, label: "All" };
                setAreaOption([allOption, ...formattedsource]);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchLeadSource();
    }, []);

    // delivery point
    const [dppoption, setdpoption] = useState([]);
    const [dp, setDp] = useState(null);
    useEffect(() => {
        const fetchLeadSource = async () => {
            try {
                const response = await axios.get(`${baseURL}/dropdown/deliverypoint`, { params: { branch_id } });
                const formattedsource = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.delivery_point,
                }));
                const allOption = { value: null, label: "All" };
                setdpoption([allOption, ...formattedsource]);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchLeadSource();
    }, []);

    const [date_fil_selt_value, setDateFilSeltValue] = useState("all");
    const [today_fil_value, setTodayFilValue] = useState(new Date());
    const [week_stdt_fil_value, setWeekSTDTFilValue] = useState(getStartOfWeek(new Date()));
    const [week_eddt_fil_value, setWeekEDDTFilValue] = useState(getEndOfWeek(new Date()));
    const [month_fil_value, setMonthFilValue] = useState(new Date());
    const [custom_stdt_fil_value, setCustomSTDTFilValue] = useState(new Date());
    const [custom_eddt_fil_value, setCustomEDDTFilValue] = useState(new Date());

    const date_fil_options = [
        { value: "all", label: "All" },
        { value: "today", label: "Today" },
        { value: "this_week", label: "This week" },
        { value: "this_month", label: "This Month" },
        { value: "custom", label: "Custom Date" }
    ];

    const handleGoClick = () => {

        const filter = {
            product: filter_prods_id || '',
            timeline: filter_tline_id || '',
            area: area || '',
            delivery_point: dp || '',
            date_filter: date_fil_selt_value || '',
        };
        if (date_fil_selt_value === 'custom') {
            filter.start_date = custom_stdt_fil_value || '';
            filter.end_date = custom_eddt_fil_value || '';
        }
        setHasFetched(false);
        if ($.fn.dataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        fetchData(filter);
        onClose();
    };

    // ------------------------------------------------ Export --------------------------------------
    const exportCSV = async () => {
        try {
            const filter = {
                product: filter_prods_id || '',
                timeline: filter_tline_id || '',
                area: area || '',
                delivery_point: dp || '',
                date_filter: date_fil_selt_value || '',
            };
            if (date_fil_selt_value === 'custom') {
                filter.start_date = custom_stdt_fil_value || '';
                filter.end_date = custom_eddt_fil_value || '';
            }
            const params = {
                ...filter,
                search: searchTerm,
                per_page: 'all',
                branch_id: branch_id,
            };

            const response = await axios.get(`${baseURL}/subscription/refund`, { params });
            const allData = response.data.data;

            const columnNames = [
                'S.No', 'Subscriber Name', 'Mobile No', 'Email ID',
                'Area',
                // 'Latitude', 'Longitude', 
                'Address', 'Product', 'Drop Date', 'Drop Reason', 'Refund Amount', 'Refund status'
            ];
            const formattedData = allData.map((item, index) => ({
                'S.No': index + 1,
                'Subscriber Name': item.lead_name,
                'Mobile No': item.lead_mobile_no,
                'Email ID': item.lead_email_id || '-',
                'Area': item.arearelation.area_name || '-',
                // 'Latitude': item.latitude || '-',
                // 'Longitude': item.longitude || '-',
                'Address': item.address || '-',
                'Product': item.product_name || '-',
                'Drop Date': formatDate(item.drop_date),
                'Drop Reason': item.drop_reason || '-',
                'Refund Amount': item.refund_amont_formatted || '-',
                'Refund status': item.refund_status === 2 ? 'Completed' : 'Pending',
            }));
            const csv = Papa.unparse({
                fields: columnNames,
                data: formattedData
            });
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'refund.csv';
            link.click();
        } catch (error) {
            console.error('Export failed:', error);
            toast.error("Export Faild");
        }
    };

    const exportExcel = async () => {
        try {

            const filter = {
                product: filter_prods_id || '',
                timeline: filter_tline_id || '',
                area: area || '',
                delivery_point: dp || '',
                date_filter: date_fil_selt_value || '',
            };
            if (date_fil_selt_value === 'custom') {
                filter.start_date = custom_stdt_fil_value || '';
                filter.end_date = custom_eddt_fil_value || '';
            }
            const params = {
                ...filter,
                search: searchTerm,
                per_page: 'all',
                branch_id: branch_id,
            };

            const response = await axios.get(`${baseURL}/subscription/refund`, { params });
            const allData = response.data.data;

            // Format the data to include the desired columns

            const formattedData = allData.map((item, index) => ({
                'S.No': index + 1,
                'Subscriber Name': item.lead_name,
                'Mobile No': item.lead_mobile_no,
                'Email ID': item.lead_email_id || '-',
                'Area': item.arearelation.area_name || '-',
                // 'Latitude': item.latitude || '-',
                // 'Longitude': item.longitude || '-',
                'Address': item.address || '-',
                'Product': item.product_name || '-',
                'Drop Date': formatDate(item.drop_date),
                'Drop Reason': item.drop_reason || '-',
                'Refund Amount': item.refund_amont_formatted || '-',
                'Refund status': item.refund_status === 2 ? 'Completed' : 'Pending',
            }));

            // Create worksheet from formatted data
            const ws = XLSX.utils.json_to_sheet(formattedData);

            // Create a new workbook and append the worksheet
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

            // Write the workbook to an Excel file and trigger the download
            XLSX.writeFile(wb, 'refund.xlsx');
        } catch (error) {
            console.error('Export failed:', error);
            toast.error("Export Faild");
        }
    };

    const print = async () => {
        try {
            const filter = {
                product: filter_prods_id || '',
                timeline: filter_tline_id || '',
                area: area || '',
                delivery_point: dp || '',
                date_filter: date_fil_selt_value || '',
            };
            if (date_fil_selt_value === 'custom') {
                filter.start_date = custom_stdt_fil_value || '';
                filter.end_date = custom_eddt_fil_value || '';
            }
            const params = {
                ...filter,
                search: searchTerm,
                per_page: 'all',
                branch_id: branch_id,
            };

            const response = await axios.get(`${baseURL}/subscription/refund`, { params });
            const allData = response.data.data;
            // Define the column names for printing
            const columnNames = [
                'S.No', 'Subscriber Name', 'Mobile No', 'Email ID',
                'Area',
                // 'Latitude', 'Longitude', 
                'Address', 'Product', 'Drop Date', 'Drop Reason', 'Refund Amount', 'Refund status'
            ];
            const formattedData = allData.map((item, index) => ({
                'S.No': index + 1,
                'Subscriber Name': item.lead_name,
                'Mobile No': item.lead_mobile_no,
                'Email ID': item.lead_email_id || '-',
                'Area': item.arearelation.area_name || '-',
                // 'Latitude': item.latitude || '-',
                // 'Longitude': item.longitude || '-',
                'Address': item.address || '-',
                'Product': item.product_name || '-',
                'Drop Date': formatDate(item.drop_date),
                'Drop Reason': item.drop_reason || '-',
                'Refund Amount': item.refund_amont_formatted || '-',
                'Refund status': item.refund_status === 2 ? 'Completed' : 'Pending',
            }));

            // Create an HTML table for printing
            let printContent = `<table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd;">
                <thead>
                    <tr style="background-color: #f2f2f2;">`;

            // Add column headers
            columnNames.forEach(col => {
                printContent += `<th style="padding: 8px; text-align: left; border: 1px solid #ddd;">${col}</th>`;
            });

            printContent += `</tr></thead><tbody>`;

            // Add the rows of data
            formattedData.forEach(row => {
                printContent += `<tr>`;
                columnNames.forEach(col => {
                    printContent += `<td style="padding: 8px; border: 1px solid #ddd;">${row[col]}</td>`;
                });
                printContent += `</tr>`;
            });

            printContent += `</tbody></table>`;

            // Open the print dialog
            const printWindow = window.open('', '', 'height=800,width=1000');
            printWindow.document.write('<html><head><title>Lead Details</title>');
            printWindow.document.write('<style>table { width: 100%; border-collapse: collapse; }</style>');
            printWindow.document.write('</head><body>');
            printWindow.document.write(printContent);
            printWindow.document.write('</body></html>');
            printWindow.document.close(); // Necessary for IE >= 10
            printWindow.print();
        } catch (error) {
            console.error('Export failed:', error);
            toast.error("Export Faild");
        }
    };

    const [selectedId, setSelecctedID] = useState("");
    const [selData, setSelData] = useState({});
    const [selType, settype] = useState("");
    const handleRefund = (id, data, val) => {
        setSelecctedID(id);
        setSelData(data);
        setModalType("Refund");
        setOpen(true);
        settype(val);
    };

    const handleCancell = (id, data) => {

        swal.fire({
            html: `
                    <div class="alert alert-info px-2 py-2" role="alert">
                        Are You Sure Want to Change Status
                        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                    </div>
                    <div class="row mb-2 text-center">
                        <label class="text-black font-w300"><b>${data.subscriber_name} - ${data.subscriber_number}</b></label>
                    </div>
                    <div class="text-center mt-4 mb-3">
                        <label class="fw-bold text-green fs-2">Cancel Refund</label>
                    </div>
                    <div class="form-group text-start mt-3">
                        <label for="reasonSelect" class="form-label">Enter Reason<span class="required">*</span></label>
                       <input type="text" id="reasonInput" class="form-control" placeholder="Enter reason here">
                    </div>
                `,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-success',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,

            preConfirm: () => {
                const reason = document.getElementById('reasonInput').value;
                if (!reason) {
                    swal.showValidationMessage('Please Enter a reason');
                    return false;
                }
                return { reason };
            }
        }).then((result) => {
            if (result.isConfirmed && result.value) {
                axios.put(`${baseURL}/payment/update_subscription_refund/${id}`, {
                    status: 2,
                    reason: result.value.reason,
                    type: 1
                })
                    .then((result) => {
                        fetchData();
                        toast.success("Refund Updated Successfully!");
                    })
                    .catch(error => {
                        console.log(error);
                        toast.error("Refund Updation Failed");
                    });
            }
        });
    };

    const [key, setKey] = useState('catering');

    return (
        <>
            <div className="d-flex align-items-center justify-content-between flex-wrap page-titles px-0 py-1 mx-0">
                <div className='mb-2'>
                    <div className="mb-0 px-0">
                        <h4 style={{ color: '#025d3a' }}>Manage Refund</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Payment Management</li>
                    </ol>
                </div>

                {open && modalType === "Refund" && (
                    <UpdateRefund show={open} onClose={() => setOpen(false)} id={selectedId} refresh={fetchData} data={selData} val={selType} />
                )}
            </div>

            <Col xl={12} className='mb-3'>
                <div className="custom-tab-1">
                    <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
                        <Nav as="ul" className="nav-tabs">
                            <Nav.Item as="li" >
                                <Nav.Link as={Link} to="/manage-refund">
                                    <i class="fa-solid fa-user-tie"></i>
                                    <label className="ms-2 fs-6">
                                        Subscription
                                    </label>
                                    {/* <Badge as="a" href="" bg=" badge-circle" className='badge-outline-success ms-2 fw-bold fs-8'>
                                        00
                                    </Badge> */}
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" >
                                <Nav.Link eventKey={'catering'}>
                                    <i class="fa-solid fa-layer-group"></i>
                                    <label className="ms-2 fs-6">
                                        Catering
                                    </label>
                                    {/* <Badge as="a" href="" bg=" badge-circle" className='badge-outline-warning ms-2 fw-bold fs-8'>
                                        00
                                    </Badge> */}
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" >
                                <Nav.Link as={Link} to="/manage-refund-corporate">
                                    <i class="fa-solid fa-hotel"></i>
                                    <label className="ms-2 fs-6">
                                        Corporate
                                    </label>
                                    {/* <Badge as="a" href="" bg=" badge-circle" className='badge-outline-danger ms-2 fw-bold fs-8'>
                                        00
                                    </Badge> */}
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </Tab.Container>
                </div>
            </Col>

            <div className="table-container">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    {/* Left: Show entries dropdown */}
                    <div>
                        <label className="me-2">Show</label>
                        <select
                            className="form-select d-inline w-auto"
                            style={{ fontSize: '0.85rem', height: '30px' }}
                            value={perPage}
                            onChange={(e) => {
                                setPerPage(Number(e.target.value));
                                setPage(1); // Reset to first page
                            }}
                        >
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                        </select>
                    </div>

                    {/* Right: Search input */}
                    <div>
                        <input
                            type="text"
                            style={{ fontSize: '0.85rem', height: '40px' }}
                            placeholder="Search..."
                            className="form-control"
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setPage(1); // Reset page on new search
                            }}
                        />
                    </div>
                </div>

                <table style={{ borderBottom: '2px solid #ddd' }} id="kt_datatable_responsive_approved" className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                    <thead>
                        <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                            <th className='min-w-100px'>Customer</th>
                            <th className='min-w-100px'>Order ID</th>
                            <th className='min-w-100px'>Ordered Date</th>
                            <th className='min-w-125px'>Canceled Date</th>
                            <th className='min-w-125px'>Reason</th>
                            <th className='min-w-125px'>Refund Amount</th>
                            <th className='min-w-50px text-center'>Authority Verification</th>
                            <th className='min-w-50px text-center'>Accounts Verification</th>
                        </tr>
                    </thead>
                    <tbody className="text-gray-600 fw-semibold fs-7">
                        {datas.length === 0 && hasFetched ? (
                            <tr>
                                <td colSpan="8" className="text-center text-muted py-2">
                                    No data available
                                </td>
                            </tr>
                        ) : (
                            <>
                                {datas.map((data, index) => (
                                    <tr key={data.sno}>
                                        <td>
                                            <label className='text-black font-w400 fs-7 text-wrap mw-auto'>{data.subscriber_name}</label>
                                            <div className='d-block'>
                                                <label className='text-dark font-w500 fs-8'>{data.subscriber_mobile_no}</label>
                                            </div>
                                        </td>
                                        <td className='align-content-center'>
                                            <label className='text-black font-w400 fs-7'>{data.order_id}</label>
                                        </td>
                                        <td className='align-content-center'>
                                            <label className='text-info fw-bold fs-7'>{formatDate(data.ordered_date)}</label>
                                        </td>
                                        <td className='align-content-center'>
                                            <label className='text-danger fw-bold fs-7'>{formatDate(data.created_at)}</label>
                                        </td>
                                        <td className='align-content-center'>
                                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>{data.refund_reason}</span></Tooltip>} >
                                                <label className='text-black font-w400 fs-7 text-truncate mw-300px'>{data.refund_reason}  </label>
                                            </OverlayTrigger>
                                        </td>
                                        <td className='align-content-center'>
                                            <label className='text-danger fw-bold fs-7'>
                                                <span><i className="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                                <span>{data.refund_amount}</span>
                                            </label>
                                        </td>
                                        <td className='text-center align-content-center'>
                                            {data.refund_status === 1 && (
                                                <span className="text-white fs-7 py-0 px-1 badge bg-success">Approved</span>
                                            )}
                                            {data.refund_status === 2 && (
                                                <div className="">
                                                    <span className="text-white fs-7 py-0 px-1 badge bg-info">Cancelled</span>
                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom"
                                                        overlay={
                                                            <Tooltip className="toltip-popover">
                                                                <span className="fs-8 text-white fw-semibold">{data.cancel_reason}</span>
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <Button variant="tp-btn-light px-2 py-1 ms-2" style={{ color: 'black' }}>
                                                            <i className="fa-solid fa-circle-question fs-6 mt-1"></i>
                                                        </Button>
                                                    </OverlayTrigger>
                                                </div>
                                            )}
                                            {data.refund_status === 0 && (
                                                <Dropdown drop="">
                                                    <Dropdown.Toggle as="a" className={`i-false cursor-pointer`}>
                                                        <Badge bg="none" className='py-1 px-2 fs-8 text-black' style={{ background: '#aaaaaaff' }}>Waiting for Approval</Badge>
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu >
                                                        <Dropdown.Item href="#" className='text-black' onClick={() => handleRefund(data.sno, data, "Auth")}>Verify</Dropdown.Item>
                                                        <Dropdown.Item href="#" className='text-black' onClick={() => handleCancell(data.sno, data)}>Cancel</Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            )}
                                        </td>
                                        <td className="text-center align-content-center">

                                            {data.accounts_status === 1 && (
                                                <span className="text-white fs-7 py-0 px-1 badge bg-success">Approved</span>
                                            )}

                                            {data.accounts_status === 2 && (
                                                <div className="d-flex align-items-center text-black fw-semibold fs-6 text-wrap mw-75">
                                                    <span className="text-white fs-7 py-0 px-1 badge bg-info">Cancelled</span>
                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom"
                                                        overlay={
                                                            <Tooltip className="toltip-popover">
                                                                <span className="fs-8 text-white fw-semibold">{data.cancel_reason}</span>
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <Button variant="tp-btn-light px-2 py-1 ms-2" style={{ color: 'black' }}>
                                                            <i className="fa-solid fa-circle-question fs-6 mt-1"></i>
                                                        </Button>
                                                    </OverlayTrigger>
                                                </div>
                                            )}

                                            {data.accounts_status === 0 && data.refund_status === 1 && (
                                                <Dropdown drop="">
                                                    <Dropdown.Toggle as="a" className={`i-false cursor-pointer`}>
                                                        <Badge bg="none" className='py-1 px-2 fs-8 text-black' style={{ background: '#aaaaaaff' }}>Waiting for Approval</Badge>
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu >
                                                        <Dropdown.Item href="#" className='text-black' onClick={() => handleRefund(data.sno, data, "Acc")}>Verify</Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            )}

                                            {data.accounts_status === 0 && data.refund_status === 2 && (
                                                <label>-</label>
                                            )}

                                            {data.accounts_status === 0 && data.refund_status === 0 && (
                                                <label>-</label>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </>
                        )}
                    </tbody>
                </table>

                <div className="d-flex justify-content-between align-items-center mt-3">
                    {/* Bottom left: Showing x to y of z entries */}
                    <div>
                        {datas.length > 0 ? (
                            <span className="text-muted">
                                Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + datas.length} of {totalPages * perPage - (perPage - datas.length)} entries
                            </span>
                        ) : (
                            <span className="text-muted">
                                Showing 0 to 0 of 0 entries
                            </span>
                        )}
                    </div>

                    {/* Bottom right: Pagination */}
                    <nav>
                        <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                            <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                            </li>
                            {[...Array(totalPages)].map((_, i) => (
                                <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
                                </li>
                            ))}
                            <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>

            <Drawer
                anchor="right"
                open={filterOpen}
                onClose={() => setFilterOpen(false)}
                disableEscapeKeyDown
                BackdropProps={{
                    onClick: (e) => e.stopPropagation(),
                }}
                sx={{
                    width: 400,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: 400,
                        boxSizing: 'border-box',
                    },
                    '@media (max-width: 375px)': {
                        '& .MuiDrawer-paper': {
                            width: 320,
                        },
                    },
                    '@media (max-width: 320px)': {
                        '& .MuiDrawer-paper': {
                            width: 280,
                        },
                    },
                }}
            >
                <div className='modal-header mb-0 px-4 pt-2 pb-0'>
                    <h5 className='fs-4' style={{ color: '#ea1d25' }}>Refund Filter</h5>
                    <div>
                        <Button variant="" type="button" size='sm' data-dismiss="modal" onClick={onClose}>
                            <span className='fs-2'>×</span>
                        </Button>
                    </div>
                </div>
                <div className='card border-0'>
                    <div className='card-body py-0'>
                        <div className='row mb-2 py-2'>

                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Products</label>
                                <Select placeholder="Select Product"
                                    value={productsOpt.find(option => option.value === filter_prods_id) || null}
                                    options={productsOpt}
                                    onChange={(selectedOption) => setFilterProdsID(selectedOption.value)}
                                />
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Timeline</label>
                                <Select placeholder="Select Timeline"
                                    value={timelineoptions.find(option => option.value === filter_tline_id) || null}
                                    options={timelineoptions}
                                    onChange={(selectedOption) => setFilterTlineID(selectedOption.value)}
                                />
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Area</label>
                                <Select placeholder="Select Area"
                                    value={areaOption.find(option => option.value === area) || null}
                                    options={areaOption}
                                    onChange={(selectedOption) => setArea(selectedOption.value)}
                                />
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Delivery Point</label>
                                <Select placeholder="Select Delivery Point"
                                    value={dppoption.find(option => option.value === dp) || null}
                                    options={dppoption}
                                    onChange={(selectedOption) => setDp(selectedOption.value)}
                                />
                            </div>

                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Date</label>
                                <Select
                                    value={date_fil_options.find(option => option.value === date_fil_selt_value)}
                                    onChange={(selectedOption) => setDateFilSeltValue(selectedOption.value)}
                                    options={date_fil_options}
                                    menuPlacement="top"
                                />
                            </div>
                            {date_fil_selt_value === "all" && <></>}
                            {date_fil_selt_value === "today" && (
                                <div className="col-lg-12 mb-2">
                                    <label className="text-black font-w500 fs-7">Today</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                        <DatePicker
                                            // value={"05/18/2020 02:20:36 PM"}
                                            value={today_fil_value}
                                            onChange={setTodayFilValue}
                                            format="DD-MM-YYYY"
                                            // format="DD/MM/YYYY hh:mm:ss A"
                                            readOnly={true}
                                        />
                                    </div>
                                </div>
                            )}
                            {date_fil_selt_value === "this_week" && (
                                <>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">Start Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={week_stdt_fil_value}
                                                onChange={setWeekSTDTFilValue}
                                                format="DD-MM-YYYY"
                                                readOnly={true}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">End Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={week_eddt_fil_value}
                                                onChange={setWeekEDDTFilValue}
                                                format="DD-MM-YYYY"
                                                calendarPosition="top-end"
                                                readOnly={true}
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                            {date_fil_selt_value === "this_month" && (
                                <div className="col-lg-12 mb-2">
                                    <label className="text-black font-w500 fs-7">This Month</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                        <DatePicker
                                            value={month_fil_value}
                                            onChange={setMonthFilValue}
                                            format="MMM-YYYY"
                                            calendarPosition="top"
                                            mode="single"
                                            onlyMonthPicker={true}
                                            readOnly={true}
                                        />
                                    </div>
                                </div>
                            )}
                            {date_fil_selt_value === "custom" && (
                                <>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">Start Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={custom_stdt_fil_value}
                                                onChange={setCustomSTDTFilValue}
                                                format="DD-MM-YYYY"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">End Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={custom_eddt_fil_value}
                                                onChange={setCustomEDDTFilValue}
                                                format="DD-MM-YYYY"
                                                calendarPosition="top-end"
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center gap-1 mb-1">
                        <Button className="me-2 btn-sm" variant="secondary" onClick={() => {
                            setFilterProdsID(null);
                            setFilterTlineID(null);
                            setDateFilSeltValue('all');
                            setArea(null);
                            setDp(null);
                            fetchData();
                            onClose();
                            // window.location.reload();
                        }}>
                            <span className='font-w400'>Reset</span>
                        </Button>
                        <Button className="me-2 btn-sm" variant="primary" onClick={handleGoClick}>
                            <span className='font-w400'>Go</span>
                        </Button>
                    </div>
                </div>
            </Drawer>

        </>
    )


}
export default Refund;